import { environment } from '@environments/environment';
/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * My Forms API
 * Respondent My Forms APIs for FormOps
 * OpenAPI spec version: 1.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  DeepNonNullable
} from '@orval/core';

import {
  Observable
} from 'rxjs';

import type {
  ExchangeMyFormsTicketRequest,
  ListMyFormsApiResponse,
  MyFormsAuthApiResponse,
  MyFormsMeApiResponse,
  RedirectToMyFormsGoogleAuthParams,
  RefreshMyFormsTokenRequest,
  StartMyFormsEmailOtpApiResponse,
  StartMyFormsEmailOtpRequest,
  VerifyMyFormsEmailOtpRequest
} from '../../models';



interface HttpClientOptions {
  headers?: HttpHeaders | Record<string, string | string[]>;
  context?: HttpContext;
  params?:
        | HttpParams
        | Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>>;
  reportProgress?: boolean;
  withCredentials?: boolean;
  credentials?: RequestCredentials;
  keepalive?: boolean;
  priority?: RequestPriority;
  cache?: RequestCache;
  mode?: RequestMode;
  redirect?: RequestRedirect;
  referrer?: string;
  integrity?: string;
  transferCache?: {includeHeaders?: string[]} | boolean;
  timeout?: number;
}



@Injectable({ providedIn: 'root' })
export class MyFormsAPIService {
  private readonly http = inject(HttpClient);
/**
 * @summary Get current My Forms respondent profile
 */
 getMyFormsMe<TData = MyFormsMeApiResponse>( options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 getMyFormsMe<TData = MyFormsMeApiResponse>( options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 getMyFormsMe<TData = MyFormsMeApiResponse>( options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  getMyFormsMe<TData = MyFormsMeApiResponse>(
     options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/api/my-forms/me`,options
    );
  }

/**
 * Returns published invite-only forms where the respondent email is an allowed contact or group member.
 * @summary List forms shared with the current respondent
 */
 listMyForms<TData = ListMyFormsApiResponse>( options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 listMyForms<TData = ListMyFormsApiResponse>( options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 listMyForms<TData = ListMyFormsApiResponse>( options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  listMyForms<TData = ListMyFormsApiResponse>(
     options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/api/my-forms/forms`,options
    );
  }

/**
 * @summary Exchange My Forms Google login ticket for tokens
 */
 exchangeMyFormsTicket<TData = MyFormsAuthApiResponse>(exchangeMyFormsTicketRequest: ExchangeMyFormsTicketRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 exchangeMyFormsTicket<TData = MyFormsAuthApiResponse>(exchangeMyFormsTicketRequest: ExchangeMyFormsTicketRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 exchangeMyFormsTicket<TData = MyFormsAuthApiResponse>(exchangeMyFormsTicketRequest: ExchangeMyFormsTicketRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  exchangeMyFormsTicket<TData = MyFormsAuthApiResponse>(
    exchangeMyFormsTicketRequest: ExchangeMyFormsTicketRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/api/my-forms/auth/exchange-ticket`,
      exchangeMyFormsTicketRequest,options
    );
  }

/**
 * @summary Refresh My Forms access token
 */
 refreshMyFormsToken<TData = MyFormsAuthApiResponse>(refreshMyFormsTokenRequest: RefreshMyFormsTokenRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 refreshMyFormsToken<TData = MyFormsAuthApiResponse>(refreshMyFormsTokenRequest: RefreshMyFormsTokenRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 refreshMyFormsToken<TData = MyFormsAuthApiResponse>(refreshMyFormsTokenRequest: RefreshMyFormsTokenRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  refreshMyFormsToken<TData = MyFormsAuthApiResponse>(
    refreshMyFormsTokenRequest: RefreshMyFormsTokenRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/api/my-forms/auth/refresh`,
      refreshMyFormsTokenRequest,options
    );
  }

/**
 * @summary Redirect to Google OAuth for My Forms
 */
 redirectToMyFormsGoogleAuth<TData = unknown>(params?: DeepNonNullable<RedirectToMyFormsGoogleAuthParams>, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 redirectToMyFormsGoogleAuth<TData = unknown>(params?: DeepNonNullable<RedirectToMyFormsGoogleAuthParams>, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 redirectToMyFormsGoogleAuth<TData = unknown>(params?: DeepNonNullable<RedirectToMyFormsGoogleAuthParams>, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  redirectToMyFormsGoogleAuth<TData = unknown>(
    params?: DeepNonNullable<RedirectToMyFormsGoogleAuthParams>, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.get<TData>(
      `${environment.baseUrl}/api/my-forms/auth/google`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }

/**
 * @summary Start My Forms email OTP login
 */
 startMyFormsEmailOtp<TData = StartMyFormsEmailOtpApiResponse>(startMyFormsEmailOtpRequest: StartMyFormsEmailOtpRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 startMyFormsEmailOtp<TData = StartMyFormsEmailOtpApiResponse>(startMyFormsEmailOtpRequest: StartMyFormsEmailOtpRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 startMyFormsEmailOtp<TData = StartMyFormsEmailOtpApiResponse>(startMyFormsEmailOtpRequest: StartMyFormsEmailOtpRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  startMyFormsEmailOtp<TData = StartMyFormsEmailOtpApiResponse>(
    startMyFormsEmailOtpRequest: StartMyFormsEmailOtpRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/api/my-forms/auth/email/start`,
      startMyFormsEmailOtpRequest,options
    );
  }

/**
 * @summary Verify My Forms email OTP and issue tokens
 */
 verifyMyFormsEmailOtp<TData = MyFormsAuthApiResponse>(verifyMyFormsEmailOtpRequest: VerifyMyFormsEmailOtpRequest, options?: HttpClientOptions & { observe?: 'body' }): Observable<TData>;
 verifyMyFormsEmailOtp<TData = MyFormsAuthApiResponse>(verifyMyFormsEmailOtpRequest: VerifyMyFormsEmailOtpRequest, options?: HttpClientOptions & { observe: 'events' }): Observable<HttpEvent<TData>>;
 verifyMyFormsEmailOtp<TData = MyFormsAuthApiResponse>(verifyMyFormsEmailOtpRequest: VerifyMyFormsEmailOtpRequest, options?: HttpClientOptions & { observe: 'response' }): Observable<AngularHttpResponse<TData>>;
  verifyMyFormsEmailOtp<TData = MyFormsAuthApiResponse>(
    verifyMyFormsEmailOtpRequest: VerifyMyFormsEmailOtpRequest, options?: HttpClientOptions & { observe?: any }): Observable<any> {
    return this.http.post<TData>(
      `${environment.baseUrl}/api/my-forms/auth/email/verify`,
      verifyMyFormsEmailOtpRequest,options
    );
  }

};

export type GetMyFormsMeClientResult = NonNullable<MyFormsMeApiResponse>
export type ListMyFormsClientResult = NonNullable<ListMyFormsApiResponse>
export type ExchangeMyFormsTicketClientResult = NonNullable<MyFormsAuthApiResponse>
export type RefreshMyFormsTokenClientResult = NonNullable<MyFormsAuthApiResponse>
export type RedirectToMyFormsGoogleAuthClientResult = NonNullable<unknown>
export type StartMyFormsEmailOtpClientResult = NonNullable<StartMyFormsEmailOtpApiResponse>
export type VerifyMyFormsEmailOtpClientResult = NonNullable<MyFormsAuthApiResponse>
